import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { BookCallProvider } from "./components/BookCallDialog";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ScrollToTop } from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import LandingDE from "./pages/LandingDE";
import IkeaPage from "./pages/IkeaPage";
import FaqPage from "./pages/FaqPage";
import ServicesPage from "./pages/ServicesPage";
import MorePage from "./pages/MorePage";
import ArticlePage from "./pages/ArticlePage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Privacy from "./pages/Privacy";

function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* English (default) */}
      <Route path="/" element={<Landing />} />
      <Route path="/ikea-assembly-munich" element={<IkeaPage lang="en" />} />
      <Route path="/services" element={<ServicesPage lang="en" />} />
      <Route path="/faq" element={<FaqPage lang="en" />} />
      <Route path="/more" element={<MorePage lang="en" />} />
      <Route path="/more/:slug" element={<ArticlePage lang="en" />} />
      <Route path="/privacy" element={<Privacy lang="en" />} />

      {/* German */}
      <Route path="/de" element={<LandingDE />} />
      <Route path="/ikea-moebelmontage-muenchen" element={<IkeaPage lang="de" />} />
      <Route path="/de/leistungen" element={<ServicesPage lang="de" />} />
      <Route path="/de/faq" element={<FaqPage lang="de" />} />
      <Route path="/de/mehr" element={<MorePage lang="de" />} />
      <Route path="/de/mehr/:slug" element={<ArticlePage lang="de" />} />
      <Route path="/de/datenschutz" element={<Privacy lang="de" />} />

      {/* Deprecated paths → redirect */}
      <Route path="/offer" element={<Navigate to="/" replace />} />
      <Route path="/book" element={<Navigate to="/" replace />} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <BookCallProvider>
            <ScrollToTop />
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BookCallProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
